import classNames from "classnames";

export const estilos = (estilo, props, tipo) => {
  const {
    color,
    round,
    disabled,
    simple,
    size,
    block,
    link,
    justIcon,
    className,
    plain,
    profile,
    info,
    chart,
    icon,
    stats
  } = props;
  let estiloClass = null;
  let tamanio = estilo[size];
  let colorElemento = estilo[color];

  if (tipo === "boton") {
    const {
      button,
      roundBoton,
      disabledBoton,
      simpleBoton,
      blockBoton,
      linkBoton,
      justIconBoton
    } = estilo;
    estiloClass = classNames({
      [button]: true,
      [tamanio]: size,
      [colorElemento]: color,
      [roundBoton]: round,
      [disabledBoton]: disabled,
      [simpleBoton]: simple,
      [blockBoton]: block,
      [linkBoton]: link,
      [justIconBoton]: justIcon,
      [className]: className
    });
  }

  if (tipo === "cardSimple") {
    const { cardSimple } = estilo;
    estiloClass = classNames({
      [cardSimple]: cardSimple,
      [estilo]: className !== undefined
    });
  }

  if (tipo === "card") {
    const { card, cardPlain, cardProfile, cardChart, cardInfo } = estilo;
    estiloClass = classNames({
      [card]: true,
      [cardPlain]: plain,
      [cardProfile]: profile,
      [cardChart]: chart,
      [cardInfo]: info,
      [estilo]: className !== undefined
    });
  }

  if (tipo === "cardHeader") {
    const {
      cardHeader,
      cardHeaderPlain,
      cardHeaderStats,
      cardHeaderIcon
    } = estilo;
    estiloClass = classNames({
      [cardHeader]: true,
      [estilo[color + "CardHeader"]]: color,
      [cardHeaderPlain]: plain,
      [cardHeaderStats]: stats,
      [cardHeaderIcon]: icon,
      [className]: className !== undefined
    });
  }

  if (tipo === "avatar") {
    const { cardAvatar, cardAvatarProfile, cardAvatarPlain } = estilo;
    estiloClass = classNames({
      [cardAvatar]: true,
      [cardAvatarProfile]: profile,
      [cardAvatarPlain]: plain,
      [className]: className !== undefined
    });
  }

  if (tipo === "body") {
    const { cardBody, cardBodyPlain, cardBodyProfile } = estilo;
    estiloClass = classNames({
      [cardBody]: true,
      [cardBodyPlain]: plain,
      [cardBodyProfile]: profile,
      [className]: className !== undefined
    });
  }

  if (tipo === "footer") {
    const {
      cardFooter,
      cardFooterPlain,
      cardFooterProfile,
      cardFooterStats,
      cardFooterChart
    } = estilo;
    estiloClass = classNames({
      [cardFooter]: true,
      [cardFooterPlain]: plain,
      [cardFooterProfile]: profile,
      [cardFooterStats]: stats,
      [cardFooterChart]: chart,
      [className]: className !== undefined
    });
  }

  if (tipo === "icono") {
    const { cardIcon } = estilo;
    estiloClass = classNames({
      [cardIcon]: true,
      [estilo[color + "CardHeader"]]: color,
      [className]: className !== undefined
    });
  }
  return estiloClass;
};
